import { CountUp } from '../../../libs/countup/countUp.min';

document.addEventListener('DOMContentLoaded', () => {
	const countupElements = document.querySelectorAll(
		'.wp-block-cancan-countup .number'
	);

	if (!countupElements.length) return;

	// Options for CountUp
	const options = {
		duration: 4,
		useEasing: true,
		separator: '',
	};

	// Intersection Observer callback
	const observerCallback = (entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const el = entry.target;
				const startValue = 0;
				const endValue =
					parseFloat(el.dataset.value) || parseFloat(el.textContent);

				// Animate only once
				if (!el.classList.contains('counted')) {
					const countUp = new CountUp(el, endValue, options);
					if (!countUp.error) {
						countUp.start();
						el.classList.add('counted');
					} else {
						console.error(countUp.error);
					}
				}

				observer.unobserve(el); // Stop observing once animated
			}
		});
	};

	const observerOptions = {
		root: null, // viewport
		rootMargin: '0px',
		threshold: 0.3,
	};

	const observer = new IntersectionObserver(
		observerCallback,
		observerOptions
	);

	countupElements.forEach((el) => {
		el.textContent = '0';

		observer.observe(el);
	});
});
